import React, {useEffect, Fragment} from "react";
import {connect} from "react-redux";

import JobBoardFiltersPopupSimpleFilter from "./JobBoardFiltersPopupSimpleFilter";
import AssignQuotePopupContentHoc from "../../PageLayout/Popups/AssignQuotePopup/assignQuotePopupContentHoc";
import JobBoardFiltersPopupSuperFilter from "./JobBoardFiltersPopupSuperFilter";
import {getStoresAndEmployees, setFiltersPopupResponse} from "./JobBoardFiltersActions";

const JobBoardFiltersPopupContent = (props) => {

  const {getStoresAndEmployees, salesPersons, stores, responseReceived} = props;

  useEffect(() => {
    if (responseReceived) {
      return false
    }
    getStoresAndEmployees();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AssignQuotePopupContentHoc className="jb-filters__content">
      {(contentDimensions) => {
        return (
          <Fragment>
            <div className="jb-filters__content-cell">
              <JobBoardFiltersPopupSimpleFilter filterName="leadType" filterKeyIntl="jobBoard.sortPanel.jobType"/>
              <JobBoardFiltersPopupSimpleFilter filterName="status" filterKeyIntl="jobBoard.sortPanel.status"/>
            </div>
            {[{
              title: "jobBoard.sortPanel.salesPerson",
              entityName: "salesPerson",
              noValuesFound: "jobBoard.filters.popup.noSalesPersons",
              renderList: salesPersons
            },{
              title: "jobBoard.sortPanel.store",
              entityName: "stores",
              noValuesFound: "jobBoard.filters.popup.noStoresFound",
              renderList: stores
            }].map(entityObject => {
              return (
                <JobBoardFiltersPopupSuperFilter key={entityObject.entityName}
                                                 responseReceived={responseReceived}
                                                 contentDimensions={contentDimensions}
                                                 entityObject={entityObject}/>
              )
            })}
          </Fragment>
        )
      }}
    </AssignQuotePopupContentHoc>
  )
};

const mapStateToProps = (store) => {
  const {filtersPopupSalesPersons, filtersPopupStores, filtersPopupResponseReceived} = store.jobBoard;
  return {
    salesPersons: filtersPopupSalesPersons,
    stores: filtersPopupStores,
    responseReceived: filtersPopupResponseReceived,
  };
};

const mapDispatchToProps = {
  getStoresAndEmployees,
  setFiltersPopupResponse,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(JobBoardFiltersPopupContent)
)
